import { getYear } from "date-fns";
import { formatDate } from "@icarius-utils/date";
import { createDateFromYYYYMM } from "@icarius-utils/date";
import { timeUtils } from ".";

export const customCallbackInformedValueType = (e) => {
    const informedValueIsObligatory = e?.data?.informedValue === "B";
    const informedValueTypeIsSelected = !(e.value === undefined || e.value === null);
    return !(informedValueIsObligatory === true && informedValueTypeIsSelected === false);
};

export const customCallbackSeniorityTo = (e) => {
    if (isNaN(e.value) || isNaN(e?.data?.seniorityFrom)) return false;
    return e.value >= e.data.seniorityFrom;
};

export const customCallbackHolidayTableGreaterEqualZero = (e) => e.value >= 0;

export const customCallbackEntryPerConceptHoursMinutesValidSyntax = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "") return /^(|0\d|1\d|2[0-3]):[0-5]\d$/.test(e.value)
    return true;
};

export const customCallbackEntryPerConceptHoursMinutes = (e, getColaboratorData) => {
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "" && e.data["Código de empleado"]) {
        const data = getColaboratorData(e.data["Código de empleado"]);
        if (data && data["HORAS DIARIAS CONTRATO"] !== null && data["HORAS DIARIAS CONTRATO"] !== "") return timeUtils.timeToDecimal(e.value) <= parseFloat(data["HORAS DIARIAS CONTRATO"]);
    }
    return true;
};

export const customCallbackEntryPerConceptHoursMinutesNoData = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "") return timeUtils.timeToDecimal(e.value) <= timeUtils.timeToDecimal("23:59");
    return true;
};

export const customCallbackMax2Decimals = (e) => {
    if (parseFloat(String(e.value).replace(',', '.')) === 0) return false;
    if (e.value !== undefined && e.value !== null && e.value !== "") return /^\d+(\.\d{3})*(,\d{0,2})*$/.test(e.value);
    return true;
};

export const customCallbackMax2DecimalsAllowZero = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") return /^\d+(\.\d{3})*(,\d{0,2})*$/.test(e.value);
    return true;
};

export const customCallbackMax2DecimalsAllowNegative = (e) => {
    if (parseFloat(String(e.value).replace(',', '.')) === 0) return false;
    if (e.value !== undefined && e.value !== null && e.value !== "") return /^-?\d+(\.\d{3})*(,\d{0,2})*$/.test(e.value);
    return true;
};

export const customCallbackMax2DecimalsAllowZeroAllowNegative = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") return /^-?\d+(\.\d{3})*(,\d{0,2})*$/.test(e.value);
    return true;
};

export const customCallbackExtraHoursTableCode = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") return /^[A-Z]+[A-Z0-9]*$/.test(e.value);
    return true;
};

export const customCallbackMax3Decimals = (e) => {
    if (parseFloat(String(e.value).replace(',', '.')) === 0) return false;
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "") return /^\d+(\.\d{3})*(,\d{0,3})*$/.test(e.value);
    return true;
};

export const customCallbackMax3DecimalsAllowZero = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "") return /^\d+(\.\d{3})*(,\d{0,3})*$/.test(e.value);
    return true;
};

export const customCallbackMax5Decimals = (e) => {
    if (parseFloat(String(e.value).replace(',', '.')) === 0) return false;
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "") return /^([1-9]\d{0,2}(\.?\d{3})*)(,(\d{1,5}))?$/.test(e.value);
    return true;
};

export const customCallbackMax5DecimalsAllowZero = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "" && e.value !== "") return /^([1-9]\d{0,2}(\.?\d{3})*|0)(,(\d{1,5}))?$/.test(e.value);
    return true;
};

export const customCallbackPeriodInverted = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") return /20\d{2}\/(0[1-9]|10|11|12)$/.test(e.value);
    return true;
};

export const customCallbackPercentage = (e) => {
    if (parseFloat(String(e.value).replace(',', '.')) === 0) return false;
    if (e.value !== undefined && e.value !== null && e.value !== "") return /(^100(\.0{1,3})?$)|(^([1-9](\d)?|0)(,\d{1,3})?$)/.test(e.value);
    return true;
};

export const customCallbackPercentageAllowZero = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") return /(^100(\.0{1,2})?$)|(^([1-9](\d)?|0)(,\d{1,3})?$)/.test(e.value);
    return true;
};

export const customCallbackYear4Digits = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") return /(^[1-2]\d{3}$)/.test(e.value);
    return true;
};

export const customCallbackPeriodFromTo = (e) => {
    const periodMin = e.data["Período desde"];
    const periodMax = e.data["Período hasta"];
    if (periodMin && periodMax) {
        const datePeriodMin = createDateFromYYYYMM(periodMin);
        const datePeriodMax = createDateFromYYYYMM(periodMax);
        return datePeriodMin <= datePeriodMax;
    }
    return true;
};

export const customCallbackDateStartEnd = (e) => {
    const startDateObject = e.data["startDate"];
    const endDateObject = e.data["endDate"];
    if (startDateObject && endDateObject) {
        const startDate = new Date(startDateObject);
        const endDate = new Date(endDateObject);
        return startDate <= endDate;
    }
    return true;
};

export const customCallbackDateStartEndYear = (e) => {
    const startDateObject = e.data["startDate"];
    const endDateObject = e.data["endDate"];
    const year = e.data["year"];
    if (startDateObject && endDateObject) {
        const startDate = typeof startDateObject === 'string' ? new Date(startDateObject.replace(/-/g, '/')) : new Date(startDateObject);
        const endDate = typeof endDateObject === 'string' ? new Date(endDateObject.replace(/-/g, '/')) : new Date(endDateObject);
        const startDateYear = getYear(startDate);
        const endDateYear = getYear(endDate);
        return Number(startDateYear) === Number(year) && Number(endDateYear) === Number(year);
    }
    return true;
};

export const customCallbackEntryPerSocietyDuplicatedConcept = (e, getVisibleRows) => {
    const conceptType = e.data["Tipo de concepto"];
    const concept = e.data["Concepto"];
    if (conceptType && concept) return !getVisibleRows().some((row) => row.data["Concepto"] === concept && row.data["Tipo de concepto"] === conceptType && row.isEditing === false);
    return true;
};

export const customCallbackExtraHoursAuthorizationDuplicatedEmployeeDate = (e, getVisibleRows) => {
    const codeName = e.data["Código de empleado"];
    const date = e.data["Fecha"];
    if (codeName && date) {
        return getVisibleRows()
            .filter((row) => {
                return (
                    row.data["Código de empleado"] === codeName
                    && formatDate(row.data["Fecha"]) === formatDate(date)
                    && row.isEditing === false
                )
            }).length < 2;
    }
    return true;
};

export const customCallbackProjectBenefitCenter = (e) => {
    const project = e.data["Proyecto"];
    const benefitCenter = e.data["Centro de costo"];
    const benefitCenter2 = e.data["Dimensión 2"];
    const benefitCenter3 = e.data["Dimensión 3"];
    const benefitCenter4 = e.data["Dimensión 4"];
    const benefitCenter5 = e.data["Dimensión 5"];
    return [
        project,
        benefitCenter,
        benefitCenter2,
        benefitCenter3,
        benefitCenter4,
        benefitCenter5,
    ].some((item) => Boolean(item));
};

export const customCallbackValidatePaymentTypeBank = (e) => {
    const paymentType = e.data["Forma de pago"];
    if (paymentType === "D") return Boolean(e.value)
    return true;
};

export const customCallbackValidatePaymentTypeCC = (e) => {
    const paymentType = e.data["Forma de pago"];
    if (paymentType === "D") return Boolean(e.value)
    return true;
};
